var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"pick-item-container"},[_c(_vm.Currcomp,{tag:"component",attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }